import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

// components
import { CButton } from '@coreui/react-pro'
import AppCard from 'src/components/AppCard'
import AppTable from 'src/components/AppTable'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from '../../components/details/time-off-balance-details/AppDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview'

// helpers
import Axios from 'src/helpers/axios'
import { formUrlQuery } from 'src/helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'
import { columnBalanceHistoryList } from '../../components/table-column/TableColumnList'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const TimeOffBalanceDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();

  const [timeOffBalanceDetails, setTimeOffBalanceDetails] = useState('')

  const [openFilePreview, setOpenFilePreview] = useState(false)

  const handleCardHeaderButton = () => {
    navigate(`/time-off-balance/edit/${id}`)
  }

  useEffect(() => {
    fetchTimeOffBalanceDetails()
  }, [id]);

  const fetchTimeOffBalanceDetails = () => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/leave/balance/employee/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setTimeOffBalanceDetails(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  // Time-Off Balance History
  const [balanceHistoryList, setBalanceHistoryList] = useState(null);
  const [balanceHistoryListCount, setBalanceHistoryListCount] = useState(0);
  const [balanceHistoryListPerPage, setBalanceHistoryListPerPage] = useState(10);
  const [activeBalanceHistoryListPage, setActiveBalanceHistoryListPage] = useState(1);
  const [searchBalanceHistoryListFilter, setSearchBalanceHistoryListFilter] = useState("");
  const [columnBalanceHistoryListSorter, setColumnBalanceHistoryListSorter] = useState({ column: "updatedAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchBalanceHistoryListFilter,
      limit: balanceHistoryListPerPage,
      offset: balanceHistoryListPerPage * activeBalanceHistoryListPage - balanceHistoryListPerPage,
      sort:
        (columnBalanceHistoryListSorter &&
          `${columnBalanceHistoryListSorter.column}%${columnBalanceHistoryListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllBalanceHistorys(queries);
  }, [
    searchBalanceHistoryListFilter,
    balanceHistoryListPerPage,
    activeBalanceHistoryListPage,
    columnBalanceHistoryListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveBalanceHistoryListPage(1)
    setSearchBalanceHistoryListFilter(search);
  }

  const fetchAllBalanceHistorys = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/leave/balance/employee/${id}/history?${queries}`
    })
      .then(({ data }) => {
        let tempBalanceHistoryList = data?.value
        tempBalanceHistoryList = tempBalanceHistoryList.map((item) => {
          return {
            ...item,
            request_id: item?.request_id ? item?.request_id : '-',
            duration: item?.duration ? item?.duration : '-',
            balance_before: item?.balance_before ? `${item?.balance_before} Days` : '-',
            balance_after: item?.balance_after ? `${item?.balance_after} Days` : '-',
            balance_affected: item?.balance_affected ? `${item?.balance_affected} Days` : '-',
            created_date: item?.created_date ? moment(item?.created_date).format('DD/MM/YYYY') : '-',
          }
        }) || []
        setBalanceHistoryList(tempBalanceHistoryList || []);
        if (activeBalanceHistoryListPage === 1) {
          setBalanceHistoryListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      <div className='d-grid gap-2 d-md-flex justify-content-md-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/time-off-balance/list')}>
          Back
        </CButton>
      </div>
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Time-Off Balance Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            timeOffBalanceDetails={timeOffBalanceDetails}
          />
        }
      />
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Time-Off Balance History</h4>}
          />
        }
        bodyContent={
          <AppTable
            timeOffBalanceListPage
            tableFilter
            tableColumns={columnBalanceHistoryList}
            tableContent={balanceHistoryList}
            contentPerPage={balanceHistoryListPerPage}
            activeContentPage={activeBalanceHistoryListPage}
            contentCount={balanceHistoryListCount}
            searchContentFilter={searchBalanceHistoryListFilter}
            setActiveContentPage={setActiveBalanceHistoryListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setBalanceHistoryListPerPage}
            setColumnContentSorter={setColumnBalanceHistoryListSorter}
            isClickable={false}
          />
        }
      />
    </>
  )
}

export default TimeOffBalanceDetails
